<template>
    <v-card>
        <v-card-title>
            {{ title }}
        </v-card-title>
        <v-card-text v-if="type != 'social'">
            This will create a messaging thread which you can then continue through the relevant app.
        </v-card-text>
        <v-card-text>
            <v-select v-if="recipientNeeded" v-model="recipient" :items="players" label="Recipient" outlined item-text="name" item-value="id" return-object></v-select>
            <v-text-field v-if="subjectNeeded" v-model="subject" label="Subject" outlined></v-text-field>
            <v-textarea v-model="message" label="Message" outlined></v-textarea>

            <v-alert type="warning" v-if="roleType == 'hacker'">
                <b>Sending messages through this will expose your name and your hacker role to the group.</b> This may be what you want, but if not you can use your hacker
                app to send messages as other people.
            </v-alert>

            <v-alert type="info" class="mb-0">
                {{ alertMessage }}
            </v-alert>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="send()">
                Send
            </v-btn>
        </v-card-actions>

        <v-snackbar v-model="snackbar" color="error">
            {{ snackbarMessage }}
            <v-btn text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'SendMessage',
    props: ['type'],
    computed: {
        title() {
            switch (this.type) {
                case "social":
                    return "Compose";
                default:
                    return "Send";
            }
        },
        alertMessage() {
            if (this.type == "social") {
                return "Your message will be shown to all players through the SoMed app.";
            } else if (this.type == "text" && this.recipient.name) {
                return `Your message will only be sent to ${this.recipient.name} through the messaging app.`;
            } else if (this.type == "email" && this.recipient.name) {
                return `Your message will only be sent to ${this.recipient.name} through the email app.`
            } else {
                return "Your message will not be shown to any players.";
            }
        },
        recipientNeeded() {
            return this.type != "social";
        },
        subjectNeeded() {
            return this.type == "email";
        },
        ...mapState([
            "players"
        ]),
        roleType() {
            return (this.$store.state.role ? this.$store.state.role.type : 'regular') || 'regular';
        }
    },
    data: () => ({
        message: "",
        recipient: {},
        snackbar: false,
        snackbarMessage: "",
        subject: ""
    }),
    methods: {
        showSnackbar(message) {
            this.snackbar = true;
            this.snackbarMessage = message;
        },
        send() {
            // Check for a recipient
            if (this.recipientNeeded && !this.recipient) {
                this.showSnackbar("You need to select a recipient before sending");
                return;
            }

            this.subject = this.subject.trim();
            if (this.subjectNeeded && this.subject.length <= 0) {
                this.showSnackbar("You need to type a subject before sending");
                return;
            }

            this.message = this.message.trim()
            if (this.message.length <= 0) {
                this.showSnackbar("You need to type a message before sending");
                return;
            }

            this.$socket.client.emit("send_message", {
                subject: this.subject,
                content: this.message,
                type: this.type,
                recipient: this.recipient.id || null
            });
        }
    },
    sockets: {
        send_event(state) {
            if (state == "sent") {
                this.message = "";
                this.recipient = {};
            }
        }
    }
}
</script>
